export const Light = 300

export const Regular = 400

export const Medium = 500

export const Semibold = 600

export const Bold = 700

export const Heavy = 800 // 100 - Hairline
// 200 - Thin
// 300 - Light
// 400 - Regular (Normal)
// 500 - Medium
// 600 - Semibold
// 700 - Bold
// 800 - Heavy
// 900 - Black
